import React from 'react'
import I18n from 'i18n-js'
import images from 'resources/assets/images'
import { infoToast } from 'utils/toast'
import './DisabledEventUserIcon.scss'

/**
 * Component that displays an icon indicating a user is disabled
 * @param {boolean} isDisabled - Whether the user is disabled
 * @returns {JSX.Element|null} The disabled user icon or null
 */
const DisabledEventUserIcon = ({ isDisabled }) => {
  if (!isDisabled) return null
  const handleClick = () => {
    infoToast(I18n.t('DisabledUserMessage'))
  }

  return (
    <div className="disabled-user-icon" onClick={handleClick} title={I18n.t('DisabledUserMessage')}>
      <img src={images.iconEyeOff} alt={I18n.t('DisabledUserMessage')} />
    </div>
  )
}

export default DisabledEventUserIcon
